import React from 'react';

const Copyright = () => {
  return (
    <div className='border-t border-white/20'>
      <div className='container mx-auto'>
        <div className='pt-6 pb-8'>
          <p className='text-base text-center'>
            Copyright &copy; 2022 Raffy Cafe. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Copyright;
